module.exports = __webpack_public_path__ + "media/images/maximize_with_paths-b766f953fff7f0679b8bade28cb3766e.svg";